import { ETFAgent } from 'actions';

const initialState = {
  isFetching: false,
  isByCategory: true,
  // similarity search results
  target: null,
  matches: [],
  // category search results
  categoryResults: [],
  search: [],
  selectedTickers: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ETFAgent.ETFAGENT_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case ETFAgent.ETFAGENT_SIMILARITY_SEARCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        target: action.target,
        matches: action.matches,
        selectedTickers: [],
      };
    case ETFAgent.ETFAGENT_CATEGORY_SEARCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        categoryResults: action.results,
        selectedTickers: [],
      };
    case ETFAgent.ETFAGENT_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    case ETFAgent.ETFAGENT_UPDATE_FIELD: {
      const { field, value } = action;
      return {
        ...state,
        [field]: value,
      };
    }
    case ETFAgent.ETFAGENT_SEARCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        search: action.data,
      };
    case ETFAgent.ETFAGENT_ADD_SELECTED_TICKER:
      return {
        ...state,
        selectedTickers: state.selectedTickers.includes(action.ticker)
          ? state.selectedTickers
          : [...state.selectedTickers, action.ticker],
      };

    case ETFAgent.ETFAGENT_REMOVE_SELECTED_TICKER:
      return {
        ...state,
        selectedTickers: state.selectedTickers.filter(
          (ticker) => ticker !== action.ticker
        ),
      };
    case ETFAgent.ETFAGENT_CLEAR_RESULTS:
      return {
        ...state,
        target: null,
        matches: [],
        categoryResults: [],
      };
    default:
      return state;
  }
}
